<template>
  <div class="container">
    <div class="apply-tab">
      <img @click="handleBack" style="width: 24px; height: 24px" src="@/assets/back.png" />
      <div>人员选择</div>
    </div>
    <div class="search">
      <van-search @focus="handleSearch" placeholder="请输入人员名搜索"></van-search>
    </div>
    <div class="company_list">
      <div v-for="(item, index) in list" :key="index" :class="['item', index === 0 ? 'first' : '']" @click="handleClick(item)">
        <div class="item_logo">
          <img v-if="item.companyLogo" :src="item.companyLogo" />
          <img v-else src="@/assets/logo.svg" />
        </div>
        <div class="item_text">
          <div>
            <span :class="[item.type === 0 ? 'parent_company' : 'son_company']">{{ item.companyName }}</span>
            <span class="item_count">（{{ item.totalCount }}）</span>
          </div>
          <div class="tag_list">
            <div v-if="item.type === 0" class="parent_tag">母公司</div>
            <div v-if="item.type === 3" class="son_tag">子公司</div>
            <div v-if="item.companyId === initialData.companyId" class="owner_tag">所属公司</div>
          </div>
        </div>
        <i style="position: absolute; right: 0;bottom: 18px" class="iconfont icon-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getAddressList } from "@/axios/services";
import { Toast } from "vant";
export default {
  data() {
    return {
      isOnwerCompany: false,
      list: [],
    };
  },
  computed: {
    ...mapState(["initialData"]),
  },
  methods: {
    getAddressList() {
      const params = {
        companyId: this.initialData.companyId,
        queryType: 3,
      };
      getAddressList(params).then((res) => {
        if (res.data.code === 0) {
          this.list = res.data.data;
          // this.list = [...this.list, ...res.data.data, ...res.data.data]
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    handleClick(item) {
      this.$router.push({
        name: "newDepartmentList",
        query: {
          companyId: item.companyId,
        },
      });
    },
    handleSearch() {
      this.$router.push({
        name: "newSearchList",
      });
    },
    handleBack() {
      this.$router.back();
    },
  },
  created() {
    this.getAddressList();
  },
};
</script>

<style lang="less" scoped>
.container {
  padding-top: 64px;
  .apply-tab {
    width: 100%;
    height: 64px;
    background: #ffffff;
    position: fixed;
    z-index: 99;
    padding-left: 10px;
    line-height: 64px;
    top: 0;
    left: 0;
    div {
      font-size: 0.48rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .search {
    width: 100%;
    background-color: #ffffff;
  }
  .company_list {
    width: 343px;
    background-color: #ffffff;
    border-radius: 4px;
    padding: 10px 16px;
    margin: 16px auto;
    .first {
      margin-top: 0 !important;
    }
    .item {
      display: flex;
      align-items: center;
      position: relative;
      height: 70px;
      border-bottom: 1px solid #f3f3f3;
      .item_logo {
        width: 50px;
        height: 50px;
        background-color: #ffffff;
        border: 1px solid;
        border-color: #e6e6e6;
        border-radius: 20px;
        overflow: hidden;
        padding: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .item_text {
        margin-left: 10px;
        .item_count {
          font-family: Source Han Sans CN;
          font-weight: 700;
          color: #999999;
          font-size: 14px;
        }
        .parent_company {
          font-family: Source Han Sans CN;
          font-weight: 700;
          color: #333333;
          font-size: 14px;
        }
        .son_company {
          font-family: Source Han Sans CN;
          color: #333333;
          font-size: 14px;
        }
        .tag_list {
          display: flex;
          margin-top: 10px;
          .parent_tag {
            height: 13px;
            background-color: rgba(255, 0, 0, 0.05);
            border: 1px solid;
            border-color: #ff0000;
            border-radius: 4px;
            font-family: Source Han Sans CN;
            color: #ff4a00;
            font-size: 8px;
            line-height: 13px;
            text-align: center;
            margin-right: 4px;
            box-sizing: content-box;
            padding: 1px;
          }
          .son_tag {
            height: 13px;
            background-color: rgba(60, 144, 255, 0.05);
            border: 1px solid;
            border-color: #3c90ff;
            border-radius: 4px;
            font-family: Source Han Sans CN;
            color: #3c90ff;
            font-size: 8px;
            line-height: 13px;
            text-align: center;
            margin-right: 4px;
            box-sizing: content-box;
            padding: 1px;
          }
          .owner_tag {
            height: 13px;
            background-color: rgba(0, 202, 123, 0.05);
            border: 1px solid;
            border-color: #00ca7b;
            border-radius: 4px;
            font-family: Source Han Sans CN;
            color: #00ca7b;
            font-size: 8px;
            line-height: 13px;
            text-align: center;
            box-sizing: content-box;
            padding: 1px;
          }
        }
      }
    }
  }
}
</style>
